import React from 'react';
import PropTypes from 'prop-types';
import {withStore, withScreenCheck} from '../hoc';
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import Body from '../components/Body';
import Footer from '../components/Footer';
import {CardReference as Reference} from '../components/Cards';
import ChevronDown from '../svg/ICON_chevronDown_Dark.svg';

/**
 * ReferencePage
 */
class ReferencePage extends React.Component {
  static displayName = 'Reference';
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };

  static defaultProps = {};

  /**
   * @constructor
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.chronPas = 3;
    this.state = {
      chronNum: 3,
    };
    this.loadMore = this.loadMore.bind(this);
  }

  /**
   * Load more references
   */
  loadMore() {
    this.setState({
      chronNum: this.state.chronNum + this.chronPas,
    });
  }

  /**
   * @override
   */
  render() {
    const references = this.props.currentPage.references();
    return (
      <div className="Reference">
        <Navbar {...this.props} />
        <Header
          {...this.props}
          images={[
            this.props.screen === 'desktop'
              ? this.props.currentPage.heroImage()
              : this.props.currentPage.heroMobileImage(),
          ]}
        >
          {this.props.currentPage.heroCaption()}
        </Header>
        <Body {...this.props}>
          {references
            .slice(0, this.state.chronNum)
            .map(reference =>
              <Reference
                key={reference.ID}
                reference={reference}
                {...this.props}
              />
            )}
          {references.size > this.state.chronNum &&
            <div className={`CardReference__more`}>
              <button onClick={this.loadMore}>
                Plus de references
                <img src={ChevronDown} alt="down" />
              </button>
            </div>}
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(ReferencePage));



// WEBPACK FOOTER //
// ./src/pages/ReferencePage.js